import React from 'react'
import { Typography, Box } from 'transfix-ui/core'
import { IScraperJobConfigurationFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationFragment'
import { Table, TableBody, Card, CardHeader } from 'transfix-ui'
import { TmsTableHeader } from './TmsTableHeader'
import { TmsTableRow } from './TmsTableRow'

interface ITmsTable {
  jobConfigs: IScraperJobConfigurationFragment[]
  tmsName: string
  setFocusedJob: React.Dispatch<React.SetStateAction<IScraperJobConfigurationFragment | undefined>>
}

export const TmsTable = ({ jobConfigs, setFocusedJob, tmsName }: ITmsTable) => {
  return (
    <Box mb={2}>
      <Card>
        <CardHeader>
          <Typography variant='h3'>{tmsName}</Typography>
        </CardHeader>
        <Table>
          <TmsTableHeader />
          <TableBody>
            {jobConfigs.map(jobConfig => (
              <TmsTableRow jobConfig={jobConfig} setFocusedJob={setFocusedJob} key={jobConfig.id} />
            ))}
          </TableBody>
        </Table>
      </Card>
    </Box>
  )
}
